var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GoogleMapLoader',{attrs:{"mapConfig":_vm.mapConfig,"apiKey":_vm.mapKey},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var google = ref.google;
var map = ref.map;
return [_c('GoogleMapMarker',{attrs:{"google":google,"map":map}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }